module.exports = __webpack_public_path__ + "img/e logo.e20c7c3c.svg";